import React, { useEffect } from "react";
import "./backoffice.css";
import { useDispatch, useSelector } from "react-redux";
import { getUsersList } from "../../../redux/actions/usersListAction";
import { openModal } from "../../../redux/actions/modalActions";
import EditCollaboratorModal from "./EditCollaboratorModal";
import Dot from "./Dot";

const CollaboratorsList = ({ filterInput }) => {
  const dispatch = useDispatch();
  const isDisplayed = useSelector(
    (state) => state.displayHonorairesReducer.isDisplayed
  );
  const { usersList } = useSelector((state) => state.userListReducer);

  useEffect(() => {
    dispatch(getUsersList());
  }, [dispatch]);

  const openUserDataModal = (documentId) => {
    dispatch(
      openModal({
        title: "Collaborateur",
        content: <EditCollaboratorModal documentId={documentId} />,
      })
    );
  };

  return (
    <div className="">
      <div className="table mt-4">
        {/* Header */}
        <div className="table-collaborators-header pink text-center ">
          <div className="table-cell">Nom</div>
          <div className="table-cell">Responsable</div>
          <div className="table-cell">Rôle</div>
          <div className="table-cell">Coordonées</div>
          <div className="table-cell">Secteur(s)</div>
          <div className="table-cell">Honoraires</div>
          <div className="table-cell">Action</div>
        </div>
      </div>
      {/* ROW */}
      {usersList
        ?.filter((user) => {
          return user?.name?.toLowerCase().includes(filterInput?.toLowerCase());
        })
        .map((user) => (
          <div className="table-collaborators-row text-center" key={user.id}>
            <div className="d-flex gap10 align-items-center">
              <img
                src={
                  user?.profile_image?.url
                    ? `${process.env.REACT_APP_IMAGE_END_POINT}${user.profile_image.url}`
                    : "./assets/mock-profile.jpg"
                }
                alt=""
                className="rounded-circle object-fit-cover"
                height={80}
                width={80}
              />
              <p>{user?.name}</p>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              {user?.responsableProgramme ? (
                <Dot color="#16A34A" />
              ) : (
                <Dot color="#DC2626" />
              )}
            </div>
            <div>
              <p>{user?.profile}</p>
            </div>
            <div className="d-flex flex-column ">
              <a href={`tel:${user?.phone_number}`} className="hoverOpacity">
                {user?.phone_number}
              </a>
              <a href={`mailto:${user?.email}`} className="hoverOpacity">
                {user?.email}
              </a>
            </div>
            <div>
              <p className="text-capitalize">
                {user?.secteurs?.map((secteur) => secteur.name).join(", ") ||
                  "--"}
              </p>
            </div>
            <div>
              <p>
                {isDisplayed && user?.honoraires != null
                  ? user?.honoraires + "%"
                  : "***"}
              </p>
            </div>
            <div>
              <img
                src="./icons/edit.svg"
                alt=""
                height={24}
                width={24}
                className="p-0 pointer"
                onClick={() => openUserDataModal(user.documentId)}
              />
            </div>
          </div>
        ))}
    </div>
  );
};

export default CollaboratorsList;
